import { render, staticRenderFns } from "./BrowserWarning.vue?vue&type=template&id=20c480c8&scoped=true"
import script from "./BrowserWarning.vue?vue&type=script&lang=js"
export * from "./BrowserWarning.vue?vue&type=script&lang=js"
import style0 from "./BrowserWarning.vue?vue&type=style&index=0&id=20c480c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c480c8",
  null
  
)

export default component.exports